module.exports = "<fuse-main>\n    \n</fuse-main>\n\n<div>\n    <toast-notifications></toast-notifications>\n</div>"